// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-dropdown[data-v-f6b5ea96]{width:100%}.dropdown-toggle[data-v-f6b5ea96]{width:100%;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dropdown-item.active[data-v-f6b5ea96]{background-color:#343a40;color:#fff}", ""]);
// Exports
module.exports = exports;
